import * as React from "react";
import {routeConfig} from "../../../../config/language/ja-JP/presentation/route_text";
import {Client} from "../../../../domain/model/client";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import Progress from "../../../common/organism/progress";
import {TBreadcrumbItem} from "../../../type/common";
import ClientClientsMainClients from "./info_clients/client_clients_main_clients";

interface IProps {
    isLoading: boolean;
    myClient?: Client;
    clients: Client[];
    clientsModalParams: { isVisible: boolean; clientId: string };
    handleUpdateRoleSubmit: (values: any) => void;
    handleClickDelete: (event: React.MouseEvent<HTMLButtonElement>) => void;
    handleClickModalOpen: (event: React.MouseEvent<HTMLButtonElement>) => void;
    handleClickModalClose: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const ClientClientsInfoClientsComponent: React.FC<IProps> = (props) => {
    const {
        myClient,
        clients,
        isLoading,
        handleUpdateRoleSubmit,
        handleClickDelete,
        handleClickModalOpen,
        handleClickModalClose,
        clientsModalParams,
    } = props;

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.clientRoot,
        routeConfig.clientMypageCompanyInfo,
        routeConfig.clientClientsInfoClients,
    ];

    return (
        <React.Fragment>
            {isLoading && <Progress canAnimation={false}/>}
            <PageWrapper>
                <Breadcrumbs breadcrumbItems={breadcrumbItems}/>
                {/*<PageTopInfo*/}
                {/*  information={pageTopInfoConfig.clientMember}*/}
                {/*  linkURL={OuterURL.clientMemberFaqURL}*/}
                {/*/>*/}

                <ClientClientsMainClients
                    myClient={myClient}
                    clients={clients}
                    clientsModalParams={clientsModalParams}
                    handleUpdateRoleSubmit={handleUpdateRoleSubmit}
                    handleClickDelete={handleClickDelete}
                    handleClickModalOpen={handleClickModalOpen}
                    handleClickModalClose={handleClickModalClose}
                />
            </PageWrapper>
        </React.Fragment>
    );
};

export default ClientClientsInfoClientsComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/clients/client_clients_info_clients.tsx